import React, { useEffect, useState } from 'react'
//import { COLORS } from '../../colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const ErrorFallback = (props) => {


    return <div className="d-flex justify-content-center align-items-center fallback-error-container"><FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" className="icon-margin mx-2" />Sorry looks like an error has occured!</div>

}

